export default [
    {
        path: '/procurement/receiving',
        name: 'receiving',
        props: true,
        component: () => import('@/views/procurement/receiving/index.vue'),
        meta: {
            pageTitle: 'Receiving',
            breadcrumb: [
                {
                text: 'Receiving',
                active: true,
                },
            ],
        },
    },
    {
        path: '/procurement/receiving/add',
        name: 'create-receiving',
        component: () => import('@/views/procurement/receiving/create.vue'),
        meta: {
            pageTitle: 'Create Receiving',
            breadcrumb: [
                {
                text: 'Receiving',
                to: { name: 'receiving' },
                },
                {
                text: 'Create Receiving',
                active: true,
                },
            ],
        },
    },
    {
        path: '/procurement/receiving/:id',
        name: 'detail-receiving',
        props: true,
        component: () => import('@/views/procurement/receiving/detail.vue'),
        meta: {
            pageTitle: 'Detail Receiving',
            breadcrumb: [
                {
                text: 'Receiving',
                to: { name: 'receiving' },
                },
                {
                text: 'Detail Receiving',
                active: true,
                },
            ],
        },
    },
]